import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEAmbossTargetType as OEAmbossTargetType_, OEAmbossStartSelectionContent} from './oe-amboss-consts';
import oeURLParameterTool, {OEURLParameter} from '../../../lib/tools/oe-url-parameter-tool';

export const OEAmbossTargetType = OEAmbossTargetType_;

export const OEAmbossTargets = new OEVersionTargets(
    {
        [OEAmbossTargetType.head]: [
            OETarget.humanHead,
            OETarget.humanCNS,
            OETarget.humanSkull,
            OETarget.humanCranialNerves,
            OETarget.humanLarynx,
            OETarget.humanEye2,
            OETarget.humanEyeLid,
            OETarget.humanEyeCornea,
            OETarget.surgeryEyeCataract,
            OETarget.humanEarMacro,
            OETarget.humanEarInner,
            OETarget.humanEarMicro,
            OETarget.humanSkinMacro
        ],
        [OEAmbossTargetType.anatomy]: [
// @ADD_TARGET_AMBOSS_OETARGET
            OETarget.humanArm,
            OETarget.humanShoulderGirdle,
            OETarget.humanUpperArmElbow,
            OETarget.humanForearm,
            OETarget.humanHand,
            OETarget.humanLeg,
            OETarget.humanHip2,
            OETarget.humanThighKnee,
            OETarget.humanLowerLeg,
            OETarget.humanAnkleFoot,
            OETarget.humanTrunk,
            OETarget.humanNeckBack,
            OETarget.humanChestWall,
            OETarget.humanAbdominalWall,
            OETarget.humanPelvis,
            OETarget.humanSpine
        ],
        [OEAmbossTargetType.organs]: [
            OETarget.humanTrunkVessel,
        ],
        [OEAmbossTargetType.biology]: [
            OETarget.humanCellEpithelium,
            OETarget.virusSarscov2
        ]
    },
    {
        [OEAmbossTargetType.head]: OETarget.humanHead,
        [OEAmbossTargetType.anatomy]: oeURLParameterTool.getValue(OEURLParameter.status) !== 'free' ? OETarget.humanTrunk : OETarget.humanKnee,
        [OEAmbossTargetType.organs]: OETarget.humanTrunkVessel,
        [OEAmbossTargetType.biology]: OETarget.humanCellEpithelium
    },
    {
        [OEAmbossTargetType.head]: OETarget.humanLarynx
    }
);

export const OEAmbossFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        let isFree = oeURLParameterTool.getValue(OEURLParameter.status) === 'free'

        return Object.assign(this.createFeatureAccessObj(), {
            headModule: !isFree,
            anatomyModule: true,
            organsModule: !isFree,
            biologyModule: !isFree,
            headTargetSelection: !isFree && !isLicensing,
            anatomyTargetSelection: !isFree && !isLicensing,
            organsTargetSelection: !isFree && !isLicensing,
            biologyTargetSelection: !isFree && !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.initialFeatureAccess();

        let featureAccess = this.initialFeatureAccess();

        let isFree = oeURLParameterTool.getValue(OEURLParameter.status) === 'free'

        if(licensingAccess.isValid && !isFree)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.headTargetSelection = true;
                featureAccess.anatomyTargetSelection = true;
                featureAccess.organsTargetSelection = true;
                featureAccess.biologyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEAmbossTargets);

export const OEAmbossStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEAmbossTargets,
    OEAmbossStartSelectionContent
);